<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    id="tableapp"
    class="content"
  >
    <div class="md-layout">
      <div class="md-layout-item">
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">
              Histórico
            </h4>
          </md-card-header>

          <md-card-content>
            <div class="md-layout">
              <select v-model="select_site">
                <option
                  disabled
                  value="-"
                >
                  Selecione um Site
                </option>
                <option
                  v-for="site in sites"
                  :value="site.id"
                >
                  {{ site.site }}
                </option>
              </select>


              <select
                v-if="select_site!=='-'"
                v-model="select_host"
              >
                <option
                  disabled
                  value="-"
                >
                  todos hosts
                </option>
                <option
                  v-for="host in sites[select_site].hosts"
                  :value="host.count"
                >
                  {{ host.name.substring(host.name.indexOf('_')+1,host.name.length) }}
                </option>
              </select>


              <select
                v-if="select_host!=='-'"
                v-model="select_application"
              >
                <option
                  disabled
                  value="-"
                >
                  todas disciplinas
                </option>
                <option
                  v-for="application in sites[select_site].hosts[select_host].applications"
                  :value="application.count"
                >
                  {{ application.name }}
                </option>
              </select>

              <!-- Seleção por Atributo // Não utilizado devida a operação necessária no backend -->
              <!-- <select v-if="select_application!==''" v-model="select_item">
                <option disabled value="">todas atributos</option>
                <option  v-for="item in sites[select_site].hosts[select_host].applications[select_application].itens" :value="item.id">{{item.name}}</option>
              </select> -->
              <input
                v-model="time_from"
                type="datetime-local"
                name="time_from"
                :max="time_till"
              >
              <input
                v-model="time_till"
                type="datetime-local"
                name="time_till"
                :max="time_today"
              >


              <button @click="printDate()">
                Buscar
              </button>

              <button
                v-if="totalItems>0 && loading_info!=true"
                @click="csvExport( )"
              >
                Export CSV
              </button>
              <i
                v-show="loading_info"
                class="fa fa-spinner"
              />
            </div>
            <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100">
              <md-table v-model="data">
                <md-table-row
                  slot="md-table-row"
                  slot-scope="{ item }"
                >
                  <md-table-cell md-label="Site">
                    {{ item.site }}
                  </md-table-cell>
                  <!-- <md-table-cell md-label="Host">{{ item.host.substring(item.host.indexOf('_')+1,item.host.length)  }}</md-table-cell> -->
                  <md-table-cell md-label="Equipamento">
                    {{ item.host.substring(item.host.indexOf('_')+1,item.host.length) }} : {{ item.application }}
                  </md-table-cell>
                  <md-table-cell md-label="Atributo">
                    {{ item.item }}
                  </md-table-cell>
                  <md-table-cell md-label="Severidade">
                    {{ item.priority }}
                  </md-table-cell>
                  <md-table-cell md-label="Descrição">
                    {{ item.description }}
                  </md-table-cell>
                  <md-table-cell md-label="Reconhecido">
                    {{ item.acknowledged }}
                  </md-table-cell>
                  <md-table-cell md-label="Comentário">
                    {{ item.comment }}
                  </md-table-cell>
                  <md-table-cell md-label="Data">
                    {{ item.clock }}
                  </md-table-cell>
                  <!-- <md-table-cell md-label="Opções"><span @click="dtEditClick(props);" > Reconhecer</span></md-table-cell> -->
                  <!-- <md-table-cell md-label="Opções">{{ item.acknowledged=="NÃO" ? "Reconhecer" : "" }} </md-table-cell> -->
                </md-table-row>
              </md-table>
            </div>
            <div style="align: center;">
              <pagination
                :page-size="itemsPerPage"
                :total-items="totalItems"
                :current-page="currentPage"
                @updatePage="changePage"
              />
            </div>

            <!-- <Spinner slot="spinner"/> -->
          </md-card-content>
        </md-card>
      </div>
    </div>
  </div>
</template>



<script>
import { SimpleTable, OrderedTable } from "@/components";
import { userService } from "../_services";

import Spinner from "vue-simple-spinner";
import Pagination from "../components/Pagination.vue";

const addZero = value => ("0" + value).slice(-2);

const formatDate = value => {
  if (value) {
    const dt = new Date(value);
    return `${addZero(dt.getDate())}/${addZero(
      dt.getMonth() + 1
    )}/${dt.getFullYear()} `;
  }
  return "";
};

export default {
  name: "Tableapp",
  components: {
    OrderedTable,
    SimpleTable,
    Spinner,
    Pagination
  },
  data() {
    return {
      sites: [],
      events:[],
      triggers:[],
      loading:true,
      loading_info: false,
      time_till:"",
      time_from:"",
      time_today: "",
      select_site:"-",
      select_host:"-",
      select_application:"-",
      select_item:"",
      priorityConvertion:["INFO","INFO","ATENCAO","MEDIA","ALTA","DESASTRE"],
      headerFields: [
        "__slot:checkboxes",
        {
          name: "site",
          label: "Site",
          sortable: true
        },
        {
          name: "host",
          label: "Host",
          sortable: true
        },
        {
          name: "application",
          label: "Application",
          sortable: true
        },
        {
          name: "item",
          label: "Item",
          sortable: true
        },
        {
          name: "priority",
          label: "Prioridade",
          sortable: true
        },
        {
          name: "description",
          label: "Descrição",
          sortable: true
        },
        {
          name: "acknowledged",
          label: "Reconhecimento",
          sortable: true
        },
        {
          name: "clock",
          label: "Data",
          sortable: true
        },
        "__slot:actions"
      ],
      data: [],
      datatableCss: {
        table: "table table-bordered table-hover table-striped table-center",
        th: "header-item",
        thWrapper: "th-wrapper",
        thWrapperCheckboxes: "th-wrapper checkboxes",
        arrowsWrapper: "arrows-wrapper",
        arrowUp: "arrow up",
        arrowDown: "arrow down",
        footer: "footer"
      },
      itemsPerPageCss: {
        select: "item-per-page-dropdown"
      },
      isLoading: false,
      sort: "asc",
      sortField: "clock",
      listItemsPerPage: [5, 10, 20, 50, 100, 99999],
      itemsPerPage: 10,
      listSiteFilter: [],
      siteFilter: null,
      listApplicationFilter: [],
      applicationFilter: 0,
      currentPage: 1,
      totalItems: 0
    };
  },
  created () {
    var date = new Date();
    this.time_today = new Date(date.toString().split("GMT")[0]+" UTC").toISOString().split(".")[0];
    this.time_till=new Date(date.toString().split("GMT")[0]+" UTC").toISOString().split(".")[0];

    var date_from = date;
    date_from.setMonth(date_from.getMonth()-1);
    this.time_from=new Date(date_from.toString().split("GMT")[0]+" UTC").toISOString().split(".")[0];
    // console.log(this.time_from)
    this.sites = JSON.parse(localStorage.getItem("sites"));
    // console.log(this.sites)
    // this.loadData();
    // this.timer = setInterval(this.loadData, 5000)
    this.loading=false;



  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    dtEditClick: props => alert("Click props:" + JSON.stringify(props)),

    // updateItemsPerPage: function(itemsPerPage) {
    //   // console.log(itemsPerPage)
    //   this.itemsPerPage = parseInt(itemsPerPage);
    //
    //
    //   if (itemsPerPage >= this.events.length) {
    //     this.data = this.events;
    //   } else {
    //     this.data = this.events.slice(0, this.itemsPerPage);
    //   }
    //   console.log(itemsPerPage)
    //   console.log(this.data)
    //
    //   this.loading=false;
    //   // console.log(this.itemsPerPage)
    //   // console.log("load data with new items per page number", itemsPerPage);
    // },


    changePage: function(currentPage, limit, done) {
      this.currentPage = currentPage;
      const start = (currentPage - 1) * this.itemsPerPage;
      const end = currentPage * this.itemsPerPage;
      this.data = this.events.slice(start, end);
      done && done();
      // console.log("load data for the new page", currentPage);
    },

    updateCurrentPage: function(currentPage) {
      this.currentPage = currentPage;
      // console.log("update current page without need to load data", currentPage);
    },
    notifyVue(messageIn,priority) {
      this.$notify({
        message:messageIn,
        icon: "add_alert",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: this.type[priority]
      });
    },
    loadData: function () {
      userService.AsingZabbixEvents(this.sites).then(zabbixEvents => {
        this.events = zabbixEvents;
        this.data=this.events.slice(0, 10);
        this.totalItems=this.events.length;
        this.loading=false;
        // console.log(zabbixEvents);
      });
      // userService.AsingZabbixProblems(this.sites).then(zabbixProblems => {
      //   this.events = zabbixProblems;
      //   this.data=this.events.slice(0, 10);
      //   this.totalItems=this.events.length;
      //   this.loading=false;
      //   console.log(zabbixProblems);
      // });
    },
    cancelAutoUpdate: function() { clearInterval(this.timer); },
    printDate: function() {
      var i=0,j=0;
      if(this.select_site===""){
        alert("Selecione um site");
      }
      else{
        this.loading_info=true;
        var date_from = new Date(this.time_from);
        var date_till = new Date(this.time_till);
        var date_from_string = (date_from.getTime()/1000).toString();
        var date_till_string = (date_till.getTime()/1000).toString();

        var hosts = [],applications=[];
        // console.log("FROM: "+date_from.getTime()/1000+" | TILL:"+ date_till.getTime()/1000+ " | Site: "+this.select_site+ " | Host: "+this.select_host+ " | Application: "+this.select_application)
        // console.log(this.select_host)
        // Threat Host selection
        if(this.select_host==="-"){

          // console.log(this.sites[this.select_site])


          // If not defined, add all hosts
          for (i = 0; i < this.sites[this.select_site].hosts.length; i++) {
            hosts.push(this.sites[this.select_site].hosts[i].id.toString());

            // If not defined, add all applications
            for (j = 0; j < this.sites[this.select_site].hosts[i].applications.length; j++) {
              applications.push(this.sites[this.select_site].hosts[i].applications[j].id.toString());
            }
          }
        }
        else{
          // Add specific host
          // console.log(this.sites[this.select_site])
          // console.log(this.sites[this.select_site].hosts[this.select_host])
          hosts.push(this.sites[this.select_site].hosts[this.select_host].id.toString());

          // Threat applications
          if(this.select_application==="-"){
            // If not defined, add all applications
            for (j = 0; j < this.sites[this.select_site].hosts[this.select_host].applications.length; j++) {
              applications.push(this.sites[this.select_site].hosts[this.select_host].applications[j].id.toString());
            }
          }
          else{
            // Add specific application
            applications.push(this.sites[this.select_site].hosts[this.select_host].applications[this.select_application].id.toString());
          }
        }
        // console.log("FROM: "+date_from.getTime()/1000+" | TILL:"+ date_till.getTime()/1000+ " | Site: "+this.sites[this.select_site].site+ " | Host: "+hosts.length+ " | Application: "+applications.length)


        userService.AsingZabbixEvents(this.sites[this.select_site],hosts,applications,date_from_string,date_till_string).then(zabbixEvents => {
          this.loading=true;
          this.events = zabbixEvents;
          this.data=this.events.slice(0, 10);
          this.totalItems=this.events.length;
          this.loading=false;
          this.loading_info=false;
          // console.log(zabbixEvents);
        });


      }
    },
    csvExport( ) {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(this.events[0]).join(";"),
        ...this.events.map(item => Object.values(item).join(";"))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "")
        .replace(/\nUsuario/gm, " | Usuario").replace(/\nNumero/gm, " | Numero");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    }
  }
};
</script>

<style>
#tableapp .items-per-page {
  height: 100%;
  display: flex;
  align-items: center;
  color: #337ab7;
}

#tableapp .ignore-css {
  all: unset;
}
</style>
